export function parseDate(d) {
  const matches = d.match(/\d+/);
  if (matches) {
    return new Date(parseInt(matches[0], 10));
  }
  return new Date();
}

export function dateDifference(start, end) {
  return Math.round((end.getTime() - start.getTime()) / 1000 / 60);
}

export function parsePlatform(p) {
  return p ? { name: p.Name, type: p.Type } : undefined;
}

export const MODES = {
  Unknown: {
    title: "Unknown",
    name: "Unknown",
    iconUrl: "img/svg/stop-bus.svg",
  },
  AVE: {
    title: "AVE",
    name: "Ave Mobilidade",
    iconUrl: "img/svg/ave.svg",
  },
  CAV: {
    title: "CAV",
    name: "Mov Cávado",
    iconUrl: "img/svg/cavado.svg",
  },
  BAR: {
    title: "BAR",
    name: "TUBA",
    iconUrl: "img/svg/tuba.svg",
  },
  BRA: {
    title: "BRA",
    name: "TUB",
    iconUrl: "img/svg/tub.svg",
  },
  MOB: {
    title: "MOB",
    name: "Mobiave",
    iconUrl: "img/svg/mobiave.svg",
  },
  GUI: {
    title: "GUI",
    name: "Guimabus",
    iconUrl: "img/svg/guimabus.svg",
  },
  BUS: {
    title: "BUS",
    name: "Get Bus",
    iconUrl: "img/svg/getbus_2.svg",
  },
  FLX: {
    title: "FLX",
    name: "Flixbus",
    iconUrl: "img/svg/flixbus.svg",
  },
  RNE: {
    title: "RNE",
    name: "Rede Expressos",
    iconUrl: "img/svg/rede-expressos.svg",
  },
  EXTALV: {
    title: "EXTALV",
    name: "Alvegal",
    iconUrl: "img/svg/alvegal.svg",
  },
  EXTAV: {
    title: "EXTAV",
    name: "Andrade Voyages",
    iconUrl: "img/svg/andrade_voyages.svg",
  },
  EXTBAR: {
    title: "EXTBAR",
    name: "Barquense",
    iconUrl: "img/svg/barquense.svg",
  },
  EXTGIR: {
    title: "EXTGIR",
    name: "Girómundo",
    iconUrl: "img/svg/giromundo.svg",
  },
  EXTSOC: {
    title: "EXTSOC",
    name: "Socintarbus",
    iconUrl: "img/svg/socintarbus.svg",
  },
  UNI: {
    title: "UNI",
    name: "Unir",
    iconUrl: "img/svg/stop-bus.svg",
  }
}

export function parseMode(agency, route) {
  if (!agency || agency == undefined || agency == '') {
    return MODES.Unknown;
  }

  switch (agency) {
    case "AVE":
      return MODES.AVE;
    case "CAV":
      return MODES.CAV;
    case "BRA":
      return MODES.BRA;
    case "BAR":
      return MODES.BAR;
    case "MOB":
      return MODES.MOB;
    case "GUI":
      return MODES.GUI;
    case "BUS":
      return MODES.BUS;
    case "FLX":
      return MODES.FLX;
    case "RNE":
      return MODES.RNE;
    case "UNI":
      return MODES.UNI;
    default:
      let routeSplit = route.split(': ')[0]
      switch (routeSplit) {
        case "Alvegal":
          return MODES.EXTALV;
        case "Andrade Voyages":
          return MODES.EXTAV;
        case "Barquense":
          return MODES.EXTBAR;
        case "Girómundo":
          return MODES.EXTGIR;
        case "Socintarbus":
          return MODES.EXTSOC;
        default:
          return MODES.Unknown;
      }

  }
}

export function replaceStopName(stopName) {
  let replacements = [
    ['Lisbon', 'Lisboa'],
    ['Guimaraes', 'Guimarães'],
    ['Fatima', 'Fátima'],
    ['Albergaria a Velha', 'Albergaria-a-Velha'],
    ['Covilha', 'Covilhã'],
    ['Murca', 'Murça'],
    ['Campanha', 'Campanhã'],
    ['Central Bus Station', 'Estação Central'],
    ['Bus Station', 'Estação'],
    ['Bus Terminal', 'Terminal'],
    ['Bus Stop', ''],
    ['Trucking Center', 'Central de Camionagem']
  ]

  let stopNameRep = ''
  replacements.forEach(rep => {
    stopNameRep = stopName.split(rep[0]).join(rep[1])
    stopName = stopNameRep
  })

  return stopName
}
